<template>
  <div class="detail-container">
    <div class="part part-one">
      <div class="avatar-area">
        <div class="avatar">
          <img :src="avatar || 'https://aliimg.changba.com/!/activity2023/come_sing_with_me/avatar_default.png'" alt="歌手头像" />
        </div>
      </div>
      <div class="info-area">
        <p>歌手：{{ detail.singer || "-" }}</p>
        <p>歌名：{{ detail.songName || "-" }}</p>
        <p>
          合唱/翻唱量：<span class="highlight">{{ detail.count || "-" }}</span>
        </p>
      </div>
      <div class="title-area">
        <img src="../assets/hot-composition.png" alt="合唱作品聚合页标题" />
      </div>
    </div>
    <div class="part part-two">
      <!-- <div class="filter-area" @click="toggleSortType">
        <div class="icon">
          <img src="https://aliimg.changba.com/!/activity2023/come_sing_with_me/icon_sort.png" alt="排序图标" />
        </div>
        <span>{{ SORT_MAP[sortIndex].label }}</span>
      </div> -->
      <div class="content-area">
        <div class="song-item" v-for="(source, sourceIndex) in sourceList" :key="sourceIndex" @click="goWorksDetail(source.workid)">
          <div class="song-item__top">
            <span class="play-times">{{ source.listen_num }}次播放</span>
            <div class="pic">
              <CbImage :src="source.cover.path" :specific="true" alt="合唱封面" />
            </div>
            <template v-if="source.listen_num > 1000">
              <div class="hottag">
                <img src="https://aliimg.changba.com/!/activity2023/come_sing_with_me/icon_hot.png" alt="HOT图标" />
              </div>
            </template>
            <template v-else>
              <div class="counts">
                <span>热度：{{ source.listen_num }}</span>
              </div>
            </template>
            <span class="opt-icon"></span>
          </div>
          <div class="song-item__bottom">
            <div class="song-item__bottom-left">
              <div class="avatar">
                <CbImage :src="source.user.headphoto" :specific="true" fallback="https://aliimg.changba.com/!/activity2023/come_sing_with_me/avatar_default.png" :size="320" alt="用户头像" />
              </div>
            </div>
            <div class="song-item__bottom-right">
              <div class="username ellipsis">{{ source.user.nickname }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="part part-three" v-if="!finished">
      <img src="../assets/btn-load-more.png" alt="加载更多" v-if="!loading" @click="fetchDetail(false)">
    </div> -->
  </div>
</template>

<script>
import { get, getGlobalParams, bridge, track } from "@changba/funny";
import { SORT_MAP } from "../config";

export default {
  name: "DetailContainer",
  data() {
    return {
      SORT_MAP,
      sourceList: [],
      sortIndex: 0,
      detail: {},
      loading: false,
      finished: false,
      page: 1,
      pageSize: 20,
    };
  },
  computed: {
    avatar() {
      return this.detail.avatar?.replace(/^http:\/\//i, "https:\/\/");
    }
  },
  watch: {
    sortIndex() {
      this.fetchDetail(true);
    },
  },
  async mounted() {
    try {
      const params = await getGlobalParams();
      const info = JSON.parse(localStorage && localStorage.getItem(`${params.userId}_CurrentDuetInfo`));
      this.detail = info;
      if (info.homepageImg) {
        this.$store.commit("setShareImg", info.homepageImg);
      }
      this.fetchDetail(true);
    } catch (error) {
      console.warn(error);
    }
  },
  methods: {
    async fetchDetail(reload = false) {
      if (this.loading) {
        return;
      }
      if (reload) {
        this.page = 1;
        this.sourceList = [];
      }
      this.loading = true;
      const { code, data, msg } = await get({
        url: `/api/activity/singWithYou/detail`,
        data: {
          duetId: this.detail.duetId,
          songId: this.detail.songid,
          type: SORT_MAP[this.sortIndex].value,
          page: this.page,
        },
      });
      this.loading = false;
      if (code === 1 && data && data.works.length) {
        this.sourceList = this.sourceList.concat(data.works);
        this.page++;
        this.finished = data.works.length < this.pageSize;
      } else {
        if (code !== 1) {
          this.$toast(msg || "系统异常，请稍后重试！");
        }
      }
    },
    toggleSortType() {
      if (this.loading) {
        return;
      }
      if (this.sortIndex < SORT_MAP.length - 1) {
        this.sortIndex++;
      } else {
        this.sortIndex--;
      }
    },
    goWorksDetail(workid) {
      track("click_element_H5_ktv", {
        element_content: this.detail.singer,
        element_content_ktv: "作品封面点击",
      });
      bridge.openPage("changba://?ac=playuserwork&workid=" + workid);
    },
    replaceLocation(location) {
      const area = location.trim();
      if (area) {
        return area.split(" ")[0];
      } else {
        return "";
      }
    },
  },
};
</script>

<style lang="scss">
.detail-container {
  position: relative;

  .part-one {
    width: 100%;
    height: 664px;
    background-image: url("https://aliimg.changba.com/!/activity2023/come_sing_with_me/bg_detailpage.png");
    background-position: top left;
    background-size: cover;
    font-size: 24px;
    line-height: 38px;
    .avatar-area {
      padding: 180px 70px 20px;
      text-align: center;
      .avatar {
        width: 275px;
        height: 184px;
        background-image: url("https://aliimg.changba.com/!/activity2023/come_sing_with_me/bg_avatar.png");
        background-repeat: no-repeat;
        background-position: top left;
        background-size: cover;
        text-align: center;
        margin: 0 auto;
        img {
          width: 163px;
          height: 163px;
          border-radius: 163px;
          margin-top: 10px;
          margin-right: 4px;
        }
      }
    }

    .info-area {
      color: #f7deff;
      text-align: center;
      .highlight {
        color: #fe71eb;
        font-weight: 500;
      }
    }

    .title-area {
      text-align: center;
      padding: 50px 0 10px;
      img {
        width: 446px;
        height: 99px;
      }
    }
  }

  .play-times {
    position: absolute;
    height: 34px;
    background: rgba(0, 0, 0, 0.6);
    border-radius: 0 17px 17px 0;
    top: 30px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    padding: 0 20px 0 10px;
    font-size: 20px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
  }

  .part-two {
    background-color: #280061;
    font-size: 20px;
    line-height: 28px;
    min-height: 70vh;
    .filter-area {
      color: #dbc2ff;
      padding: 0 30px;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      .icon {
        padding: 8px 20px;
        img {
          width: 25px;
        }
      }
    }
    .content-area {
      display: flex;
      justify-content: left;
      align-items: flex-start;
      flex-wrap: wrap;
      padding: 0 20px 10px;
      .song-item {
        width: 50%;
        padding: 10px 15px;
        margin: 0 0 12px;

        &__top {
          position: relative;

          .opt-icon {
            position: absolute;
            bottom: 7px;
            right: 7px;
            display: inline-block;
            background-image: url("../assets/play-icon.png");
            background-size: 100% 100%;
            background-repeat: no-repeat;
            background-position: center center;
            width: 94px;
            height: 94px;
          }

          .pic {
            width: 324px;
            height: 350px;
            background-color: #b570d2ab;
            border-radius: 15px 15px 0 0;

            img {
              border-radius: 15px 15px 0 0;
              width: 100%;
              height: 100%;
              object-fit: cover;
            }
          }

          .hottag {
            position: absolute;
            right: 10px;
            top: 10px;
            width: 47px;
            img {
              width: 100%;
            }
          }

          .counts {
            position: absolute;
            right: 20px;
            top: 20px;
            width: 150px;
            padding: 15px 0;
            text-align: center;
            color: #ffffff;
            background: rgba(0, 0, 0, 0.13);
            border-radius: 30px;
          }
        }

        &__bottom {
          background-image: linear-gradient(90deg, #ffffff, #ffc0f7);
          display: flex;
          justify-content: space-around;
          align-items: center;
          border-radius: 0 0 15px 15px;
          padding: 0 0 0 20px;
          height: 78px;

          &-left {
            .avatar {
              width: 52px;
              height: 52px;

              img {
                width: 100%;
                border-radius: 50px;
              }
            }
          }

          &-right {
            padding: 10px 0 10px 20px;
            flex: 1;
            .username {
              color: #240155;
              line-height: 28px;
              padding: 10px 0;
            }
            .tags {
              .tag-item {
                font-size: 18px;
                line-height: 26px;
                color: #7ab3ff;
                border: 2px solid #7ab3ff;
                background: rgba(238, 244, 255, 0.66);
                border-radius: 20px;
                display: inline-block;
                padding: 5px 15px;
                width: 105px;
                text-align: center;
                &.age {
                  color: #fe7cd2;
                  border-color: #fe7cd2;
                  margin-left: 5px;
                  background: rgba(255, 230, 250, 0.59);
                }
              }
            }
          }
        }
      }
    }
  }

  .part-three {
    padding-top: 70px;
    height: 210px;
    text-align: center;

    img {
      width: 698px;
      height: 50px;
    }
  }
}
</style>
